import React from 'react'
import cn from 'classnames'
import styles from './answer-gate.module.scss'
import { GitBranch } from 'lucide-react'

const AnswerGate = ({ childCount, hover, isSelected }) => {
    return (
        <div
            className={cn(styles.answerGate, hover && styles.hover, isSelected && styles.selected)}
        >
            <span className={styles.count}>
                {childCount === 0 && <GitBranch className={styles.branchIcon} />}
                {childCount > 0 && Math.min(childCount, 99)}
            </span>
            {childCount > 99 && <span className={styles.gateOverflow}>+</span>}
        </div>
    )
}

export default AnswerGate
